import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Grow } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {},
  frameWrapper: {
    height: `calc(100vh - ${62}px)`,
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  epub3: {
    height: `calc(100vh - 65px)`,
    overflowY: 'hidden',
  },
  quizzes: {
    height: `calc(100vh - 65px)`,
    overflowY: 'hidden',
  },
  html5: {},
  iframe: {
    padding: 0,
    height: '100%',
    boxSizing: 'border-box',
    display: 'block',
    border: 'none',
  },
  scaledIframeContainer: {
    overflow: 'hidden',
    position: 'relative',
    margin: 'auto',
    flexShrink: 0,
  },
  scaledIframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: 0,
    border: 'none',
    transformOrigin: 'top left',
  },
}))

const ReaderFrame = React.forwardRef(
  (
    {
      variant = 'epub3',
      frameSrc = '',
      loaded = false,
      frameMargin = '0px',
      onLoad = () => { },
      contentWidth,
      contentHeight,
    },
    ref
  ) => {
    const classes = useStyles()
    const wrapperRef = useRef(null)
    const [scale, setScale] = useState(1)

    useEffect(() => {
      if (!contentWidth || !wrapperRef.current) return

      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          setScale(entry.contentRect.width / contentWidth)
        }
      })

      observer.observe(wrapperRef.current)
      return () => observer.disconnect()
    }, [contentWidth])

    return (
      <>
        {frameSrc ? (
          <div
            ref={wrapperRef}
            className={clsx(classes.frameWrapper, {
              [classes.epub3]: variant === 'epub3',
              [classes.html5]: variant === 'html5' || variant === 'digiiebook',
              [classes.quizzes]: variant === 'quizzes',
            })}
          >
            {contentWidth && contentHeight ? (
              <Grow in={loaded}>
                <div
                  className={classes.scaledIframeContainer}
                  style={{
                    width: contentWidth * scale,
                    height: contentHeight * scale,
                  }}
                >
                  <iframe
                    ref={ref}
                    id="iframe"
                    name="iframe"
                    loading="lazy"
                    title="Reader"
                    src={frameSrc}
                    onLoad={onLoad}
                    allowFullScreen
                    frameBorder="0"
                    className={classes.scaledIframe}
                    style={{
                      width: contentWidth,
                      height: contentHeight,
                      transform: `scale(${scale})`,
                    }}
                  />
                </div>
              </Grow>
            ) : (
              <Grow in={loaded}>
                <iframe
                  ref={ref}
                  id="iframe"
                  name="iframe"
                  loading="lazy"
                  title="Reader"
                  src={frameSrc}
                  onLoad={onLoad}
                  allowFullScreen
                  frameBorder="0"
                  style={{
                    width: '100%',
                    ...(variant === 'epub3'
                      ? {
                        width: 1060,
                        maxWidth: '100%',
                        marginLeft: frameMargin,
                        alignSelf: 'flex-start',
                      }
                      : {
                        maxWidth: 1280,
                      }),
                    height: (variant === 'quizzes' || variant === 'epub3') ? 'calc(100vh - 65px)' : '100%',
                    minHeight:
                      (variant === 'quizzes' || variant === 'epub3') ? 'calc(100vh - 65px)' : undefined,
                    flex: (variant === 'quizzes' || variant === 'epub3') ? 1 : undefined,
                    border: 'none',
                    padding: 0,
                    display: 'block',
                    boxSizing: 'border-box',
                    flexShrink: 0,
                  }}
                  className={clsx(classes.iframe)}
                />
              </Grow>
            )}
          </div>
        ) : null}
      </>
    )
  }
)

ReaderFrame.displayName = ReaderFrame

ReaderFrame.propTypes = {
  loaded: PropTypes.bool,
  frameSrc: PropTypes.string,
  frameMargin: PropTypes.string,
  onLoad: PropTypes.func,
  variant: PropTypes.string,
  contentWidth: PropTypes.number,
  contentHeight: PropTypes.number,
}

export default ReaderFrame
